import React, { useRef, useState } from "react";
import Contract from "./components/Contract";

const ContractPreviewModal = ({ onClose, type, modal }) => {
  return (
    <>
      <div className="model" onClick={onClose}>
        <div
          className={`bg-white rounded-lg max-w-5xl py-8 px-6 mx-auto relative h-2/3 overflow-auto`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Contract type={type} onClose={onClose} modal={modal} />
        </div>
      </div>
    </>
  );
};

export default ContractPreviewModal;
